import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "area_section"
}
const _hoisted_2 = { class: "area_contents" }
const _hoisted_3 = { class: "area_contents_body" }
const _hoisted_4 = { class: "areaGrid" }
const _hoisted_5 = { class: "last_line" }
const _hoisted_6 = { class: "last_line" }
const _hoisted_7 = { class: "last_line" }
const _hoisted_8 = { class: "area_contents" }
const _hoisted_9 = { class: "area_contents_body" }
const _hoisted_10 = { class: "areaGrid" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "last_line" }
const _hoisted_13 = { class: "last_line" }
const _hoisted_14 = { class: "last_line" }
const _hoisted_15 = { class: "last_line" }
const _hoisted_16 = { class: "last_line" }
const _hoisted_17 = { class: "last_line" }
const _hoisted_18 = { class: "area_contents" }
const _hoisted_19 = { class: "area_contents_body" }
const _hoisted_20 = { class: "areaGrid" }
const _hoisted_21 = { class: "last_line" }
const _hoisted_22 = { class: "last_line" }
const _hoisted_23 = { class: "last_line" }
const _hoisted_24 = { class: "last_line" }
const _hoisted_25 = { class: "last_line" }
const _hoisted_26 = { class: "last_line" }
const _hoisted_27 = { class: "last_line" }
const _hoisted_28 = { class: "last_line" }
const _hoisted_29 = { class: "last_line" }
const _hoisted_30 = { class: "last_line" }
const _hoisted_31 = { class: "last_line" }
const _hoisted_32 = { class: "last_line" }
const _hoisted_33 = { class: "area_contents" }
const _hoisted_34 = { class: "area_contents_body" }
const _hoisted_35 = { class: "areaGrid" }
const _hoisted_36 = { class: "last_line" }
const _hoisted_37 = { class: "last_line" }
const _hoisted_38 = { class: "last_line" }
const _hoisted_39 = { class: "last_line" }
const _hoisted_40 = { class: "last_line" }
const _hoisted_41 = { class: "last_line" }
const _hoisted_42 = { class: "last_line" }
const _hoisted_43 = { class: "area_contents" }
const _hoisted_44 = { class: "area_contents_body" }
const _hoisted_45 = { class: "areaGrid" }
const _hoisted_46 = { class: "last_line" }
const _hoisted_47 = { class: "last_line" }
const _hoisted_48 = { class: "last_line" }
const _hoisted_49 = { class: "last_line" }
const _hoisted_50 = { class: "last_line" }
const _hoisted_51 = { class: "last_line" }
const _hoisted_52 = { class: "last_line" }
const _hoisted_53 = { class: "last_line" }
const _hoisted_54 = { class: "last_line" }
const _hoisted_55 = { class: "last_line" }
const _hoisted_56 = { class: "area_contents" }
const _hoisted_57 = { class: "area_contents_body" }
const _hoisted_58 = { class: "areaGrid" }
const _hoisted_59 = { class: "last_line" }
const _hoisted_60 = { class: "last_line" }
const _hoisted_61 = { class: "last_line" }
const _hoisted_62 = { class: "last_line" }
const _hoisted_63 = { class: "last_line" }
const _hoisted_64 = { class: "last_line" }
const _hoisted_65 = { class: "last_line" }
const _hoisted_66 = { class: "last_line" }
const _hoisted_67 = { class: "last_line" }
const _hoisted_68 = { class: "last_line" }
const _hoisted_69 = { class: "area_contents" }
const _hoisted_70 = { class: "area_contents_body" }
const _hoisted_71 = { class: "areaGrid" }
const _hoisted_72 = { class: "last_line" }
const _hoisted_73 = { class: "last_line" }
const _hoisted_74 = { class: "last_line" }
const _hoisted_75 = { class: "last_line" }
const _hoisted_76 = { class: "last_line" }
const _hoisted_77 = { class: "last_line" }
const _hoisted_78 = { class: "last_line" }
const _hoisted_79 = { class: "last_line" }
const _hoisted_80 = { class: "last_line" }
const _hoisted_81 = { class: "last_line" }
const _hoisted_82 = { class: "last_line" }
const _hoisted_83 = { class: "last_line" }
const _hoisted_84 = { class: "last_line" }
const _hoisted_85 = { class: "last_line" }
const _hoisted_86 = { class: "last_line" }
const _hoisted_87 = { class: "last_line" }
const _hoisted_88 = { class: "last_line" }
const _hoisted_89 = { class: "area_contents" }
const _hoisted_90 = { class: "area_contents_body" }
const _hoisted_91 = { class: "areaGrid" }
const _hoisted_92 = { class: "last_line" }
const _hoisted_93 = { class: "last_line" }
const _hoisted_94 = { class: "last_line" }
const _hoisted_95 = { class: "last_line" }
const _hoisted_96 = { class: "last_line" }
const _hoisted_97 = { class: "last_line" }
const _hoisted_98 = { class: "last_line" }
const _hoisted_99 = { class: "area_contents" }
const _hoisted_100 = { class: "area_contents_body" }
const _hoisted_101 = { class: "areaGrid" }
const _hoisted_102 = { class: "last_line" }
const _hoisted_103 = { class: "last_line" }
const _hoisted_104 = { class: "last_line" }
const _hoisted_105 = { class: "last_line" }
const _hoisted_106 = { class: "area_contents" }
const _hoisted_107 = { class: "area_contents_body" }
const _hoisted_108 = { class: "areaGrid" }
const _hoisted_109 = { class: "last_line" }
const _hoisted_110 = { class: "last_line" }
const _hoisted_111 = { class: "last_line" }
const _hoisted_112 = { class: "last_line" }
const _hoisted_113 = { class: "last_line" }
const _hoisted_114 = { class: "last_line" }
const _hoisted_115 = { class: "last_line" }
const _hoisted_116 = { class: "area_contents" }
const _hoisted_117 = { class: "area_contents_body" }
const _hoisted_118 = {
  key: 0,
  class: "areaGrid"
}
const _hoisted_119 = { class: "last_line" }
const _hoisted_120 = { class: "last_line" }
const _hoisted_121 = { class: "last_line" }
const _hoisted_122 = { class: "last_line" }
const _hoisted_123 = { class: "last_line" }
const _hoisted_124 = { class: "last_line" }
const _hoisted_125 = { class: "last_line" }
const _hoisted_126 = { class: "last_line" }
const _hoisted_127 = { class: "last_line" }
const _hoisted_128 = { class: "last_line" }
const _hoisted_129 = {
  key: 1,
  class: "areaGrid"
}
const _hoisted_130 = { class: "last_line" }
const _hoisted_131 = { class: "last_line" }
const _hoisted_132 = { class: "last_line" }
const _hoisted_133 = { class: "last_line" }
const _hoisted_134 = { class: "last_line" }
const _hoisted_135 = { class: "last_line" }
const _hoisted_136 = { class: "last_line" }
const _hoisted_137 = { class: "last_line" }
const _hoisted_138 = { class: "last_line" }
const _hoisted_139 = { class: "last_line" }
const _hoisted_140 = { class: "last_line" }
const _hoisted_141 = { class: "last_line" }
const _hoisted_142 = { class: "last_line" }
const _hoisted_143 = { class: "last_line" }
const _hoisted_144 = { class: "last_line" }
const _hoisted_145 = { class: "last_line" }
const _hoisted_146 = { class: "area_contents" }
const _hoisted_147 = { class: "area_contents_body" }
const _hoisted_148 = { class: "areaGrid" }
const _hoisted_149 = { class: "last_line" }
const _hoisted_150 = { class: "last_line" }
const _hoisted_151 = { class: "last_line" }
const _hoisted_152 = { class: "last_line" }
const _hoisted_153 = { class: "last_line" }
const _hoisted_154 = { class: "last_line" }
const _hoisted_155 = { class: "last_line" }
const _hoisted_156 = { class: "last_line" }
const _hoisted_157 = { class: "last_line" }
const _hoisted_158 = { class: "last_line" }
const _hoisted_159 = { class: "last_line" }
const _hoisted_160 = { class: "last_line" }
const _hoisted_161 = { class: "last_line" }
const _hoisted_162 = { class: "last_line" }
const _hoisted_163 = { class: "last_line" }
const _hoisted_164 = { class: "last_line" }
const _hoisted_165 = { class: "last_line" }
const _hoisted_166 = { class: "last_line" }
const _hoisted_167 = { class: "last_line" }
const _hoisted_168 = { class: "last_line" }
const _hoisted_169 = { class: "last_line" }
const _hoisted_170 = { class: "last_line" }
const _hoisted_171 = { class: "last_line" }
const _hoisted_172 = { class: "last_line" }
const _hoisted_173 = { class: "last_line" }
const _hoisted_174 = { class: "area_contents_body" }
const _hoisted_175 = { class: "areaGrid" }
const _hoisted_176 = { class: "last_line" }
const _hoisted_177 = { class: "last_line" }
const _hoisted_178 = { class: "last_line" }
const _hoisted_179 = { class: "last_line" }
const _hoisted_180 = { class: "last_line" }
const _hoisted_181 = { class: "last_line" }
const _hoisted_182 = { class: "last_line" }
const _hoisted_183 = { class: "last_line" }
const _hoisted_184 = { class: "last_line" }
const _hoisted_185 = { class: "last_line" }
const _hoisted_186 = { class: "last_line" }
const _hoisted_187 = { class: "last_line" }
const _hoisted_188 = { class: "last_line" }
const _hoisted_189 = { class: "last_line" }
const _hoisted_190 = { class: "last_line" }
const _hoisted_191 = { class: "last_line" }
const _hoisted_192 = { class: "last_line" }
const _hoisted_193 = { class: "last_line" }
const _hoisted_194 = { class: "last_line" }
const _hoisted_195 = {
  key: 0,
  class: "area_contents"
}
const _hoisted_196 = { class: "area_contents_body" }
const _hoisted_197 = { class: "areaGrid" }
const _hoisted_198 = { class: "last_line" }
const _hoisted_199 = { class: "last_line" }
const _hoisted_200 = { class: "last_line" }
const _hoisted_201 = { class: "last_line" }
const _hoisted_202 = { class: "last_line" }
const _hoisted_203 = { class: "last_line" }
const _hoisted_204 = { class: "last_line" }
const _hoisted_205 = { class: "last_line" }
const _hoisted_206 = { class: "last_line" }
const _hoisted_207 = { class: "last_line" }
const _hoisted_208 = { class: "last_line" }
const _hoisted_209 = { class: "last_line" }
const _hoisted_210 = { class: "last_line" }
const _hoisted_211 = { class: "last_line" }
const _hoisted_212 = { class: "last_line" }
const _hoisted_213 = { class: "last_line" }
const _hoisted_214 = { class: "area_contents" }
const _hoisted_215 = { class: "area_contents_body" }
const _hoisted_216 = { class: "areaGrid" }
const _hoisted_217 = { class: "last_line" }
const _hoisted_218 = { class: "last_line" }
const _hoisted_219 = { class: "last_line" }
const _hoisted_220 = { class: "last_line" }
const _hoisted_221 = { class: "last_line" }
const _hoisted_222 = { class: "last_line" }
const _hoisted_223 = { class: "last_line" }
const _hoisted_224 = { class: "last_line" }
const _hoisted_225 = { class: "last_line" }
const _hoisted_226 = { class: "last_line" }
const _hoisted_227 = { class: "last_line" }
const _hoisted_228 = { class: "area_contents" }
const _hoisted_229 = { class: "area_contents_body" }
const _hoisted_230 = { class: "areaGrid" }
const _hoisted_231 = { class: "last_line" }
const _hoisted_232 = { class: "last_line" }
const _hoisted_233 = { class: "last_line" }
const _hoisted_234 = { class: "last_line" }
const _hoisted_235 = { class: "area_contents" }
const _hoisted_236 = { class: "area_contents_body" }
const _hoisted_237 = { class: "areaGrid" }
const _hoisted_238 = { class: "last_line" }
const _hoisted_239 = { class: "last_line" }
const _hoisted_240 = { class: "last_line" }
const _hoisted_241 = { class: "last_line" }
const _hoisted_242 = { class: "area_contents" }
const _hoisted_243 = { class: "area_contents_body" }
const _hoisted_244 = { class: "areaGrid" }
const _hoisted_245 = { class: "last_line" }
const _hoisted_246 = { class: "last_line" }
const _hoisted_247 = { class: "last_line" }
const _hoisted_248 = { class: "last_line" }
const _hoisted_249 = { class: "area_contents" }
const _hoisted_250 = { class: "area_contents_body" }
const _hoisted_251 = { class: "areaGrid" }
const _hoisted_252 = { class: "last_line" }
const _hoisted_253 = { class: "last_line" }
const _hoisted_254 = { class: "last_line" }
const _hoisted_255 = { class: "last_line" }
const _hoisted_256 = { class: "last_line" }
const _hoisted_257 = { class: "last_line" }
const _hoisted_258 = { class: "last_line" }
const _hoisted_259 = { class: "last_line" }
const _hoisted_260 = { class: "last_line" }
const _hoisted_261 = { class: "last_line" }
const _hoisted_262 = { class: "last_line" }
const _hoisted_263 = { class: "last_line" }
const _hoisted_264 = { class: "last_line" }
const _hoisted_265 = { class: "area_contents" }
const _hoisted_266 = { class: "area_contents_body" }
const _hoisted_267 = { class: "areaGrid" }
const _hoisted_268 = {
  key: 1,
  class: "area_section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.state.data != null && $setup.state.data.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "실인원")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "신규 내담자"),
                  _createElementVNode("th", { scope: "col" }, "실인원"),
                  _createElementVNode("th", { scope: "col" }, "1인당 평균 상담건수")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(998, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(999, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString($setup.CommonUtils.getCntByCn(999, $setup.state.data) === 0
                                        ? 0
                                        : Math.round($setup.CommonUtils.getCntByCn(997, $setup.state.data) / $setup.CommonUtils.getCntByCn(999, $setup.state.data))), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "초기상담유형")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("th", { scope: "col" }, "전화상담", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("th", { scope: "col" }, "내방상담", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("th", { scope: "col" }, "방문상담", -1)),
                  _createElementVNode("th", {
                    scope: "col",
                    textContent: _toDisplayString($setup.state.sYear < 2019 ? '현장상담' : '아웃리치')
                  }, null, 8, _hoisted_11),
                  _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "col" }, "사이버", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(2, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(3, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString($setup.state.sYear < 2019
                                        ? $setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(4, $setup.state.data))
                                        : $setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(250, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(6, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString($setup.state.sYear < 2019
                                        ? $setup.CommonUtils.numberFormat(
                                              $setup.CommonUtils.getCntByCn(1, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(2, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(3, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(4, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(6, $setup.state.data),
                                          )
                                        : $setup.CommonUtils.numberFormat(
                                              $setup.CommonUtils.getCntByCn(1, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(2, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(3, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(250, $setup.state.data) +
                                                  $setup.CommonUtils.getCntByCn(6, $setup.state.data),
                                          )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "기관인지경로")
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "1366"),
                  _createElementVNode("th", { scope: "col" }, "117"),
                  _createElementVNode("th", { scope: "col" }, "검찰/경찰/법원"),
                  _createElementVNode("th", { scope: "col" }, "홍보(인터넷,114,언론보도등)"),
                  _createElementVNode("th", { scope: "col" }, "지인소개"),
                  _createElementVNode("th", { scope: "col" }, "유관기관"),
                  _createElementVNode("th", { scope: "col" }, "성매매방지기관"),
                  _createElementVNode("th", { scope: "col" }, "학교"),
                  _createElementVNode("th", { scope: "col" }, "홍보물품"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_21, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(8, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(9, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(10, $setup.state.data) + $setup.CommonUtils.getCntByCn(221, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(12, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(11, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(222, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(13, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(14, $setup.state.data) + $setup.CommonUtils.getCntByCn(223, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(227, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(228, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_29, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(15, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_30, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(224, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_31, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(186, $setup.state.data) + $setup.CommonUtils.getCntByCn(16, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_32, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(8, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(9, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(10, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(221, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(11, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(12, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(222, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(13, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(14, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(223, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(227, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(228, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(15, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(224, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(186, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(16, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담의뢰인")
          ], -1)),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "본인"),
                  _createElementVNode("th", { scope: "col" }, "가족친인척"),
                  _createElementVNode("th", { scope: "col" }, "동료/이웃"),
                  _createElementVNode("th", { scope: "col" }, "타기관"),
                  _createElementVNode("th", { scope: "col" }, "유관기관"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_36, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(164, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_37, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(165, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_38, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(166, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(238, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(239, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", _hoisted_39, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(167, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_40, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(237, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_41, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(225, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_42, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(164, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(165, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(166, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(238, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(239, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(167, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(237, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(225, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "나이")
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("table", _hoisted_45, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "13세이하"),
                  _createElementVNode("th", { scope: "col" }, "14~16세"),
                  _createElementVNode("th", { scope: "col" }, "17~19세"),
                  _createElementVNode("th", { scope: "col" }, "20~29세"),
                  _createElementVNode("th", { scope: "col" }, "30~39세"),
                  _createElementVNode("th", { scope: "col" }, "40~49세"),
                  _createElementVNode("th", { scope: "col" }, "50~59세"),
                  _createElementVNode("th", { scope: "col" }, "60세이상"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_46, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(240, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_47, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(241, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_48, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(242, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_49, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(243, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_50, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(244, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_51, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(245, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_52, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(246, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_53, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(247, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_54, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(248, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_55, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(240, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(241, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(242, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(243, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(244, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(245, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(246, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(247, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(248, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "만나이")
          ], -1)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("table", _hoisted_58, [
              _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 13세이하 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 12세 이하) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 14~16세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 13~15세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 17~19세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 16~18세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 20~29세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 19~28세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 30~39세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 29~38세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 40~49세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 39~38세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 50~59세 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 49~58세) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 60세이상 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (만 59세 이상) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_59, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(280, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_60, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(281, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_61, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(282, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_62, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(283, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_63, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(284, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_64, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(285, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_65, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(286, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_66, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(287, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_67, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(288, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_68, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(280, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(281, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(282, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(283, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(284, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(285, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(286, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(287, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(288, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "학력")
          ], -1)),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("table", _hoisted_71, [
              _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "없음"),
                  _createElementVNode("th", { scope: "col" }, "초교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "초교졸"),
                  _createElementVNode("th", { scope: "col" }, "중재"),
                  _createElementVNode("th", { scope: "col" }, "중교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "중교졸"),
                  _createElementVNode("th", { scope: "col" }, "고재"),
                  _createElementVNode("th", { scope: "col" }, "고교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "고교졸"),
                  _createElementVNode("th", { scope: "col" }, "대중퇴"),
                  _createElementVNode("th", { scope: "col" }, "대재"),
                  _createElementVNode("th", { scope: "col" }, "대졸"),
                  _createElementVNode("th", { scope: "col" }, "대학원재"),
                  _createElementVNode("th", { scope: "col" }, "대학원졸"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_72, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(57, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_73, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(58, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_74, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(59, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_75, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(210, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_76, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(60, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_77, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(61, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_78, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(211, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_79, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(62, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_80, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(63, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_81, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(64, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_82, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(65, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_83, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(66, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_84, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(67, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_85, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(68, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_86, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(69, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_87, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(70, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_88, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(57, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(58, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(59, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(210, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(60, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(61, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(211, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(62, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(63, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(64, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(65, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(66, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(67, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(68, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(69, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(70, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "혼인여부")
          ], -1)),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("table", _hoisted_91, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "미혼"),
                  _createElementVNode("th", { scope: "col" }, "동거"),
                  _createElementVNode("th", { scope: "col" }, "이혼"),
                  _createElementVNode("th", { scope: "col" }, "혼인 중"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_92, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(91, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_93, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(92, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_94, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(93, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_95, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(94, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_96, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(95, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_97, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(96, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_98, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(91, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(92, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(93, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(94, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(95, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(96, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "가족관계")
          ], -1)),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("table", _hoisted_101, [
              _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "보호자 있음"),
                  _createElementVNode("th", { scope: "col" }, "보호자 없음"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_102, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(97, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_103, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(98, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_104, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(99, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_105, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(97, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(98, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(99, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_106, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "자녀여부")
          ], -1)),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("table", _hoisted_108, [
              _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "자녀 없음"),
                  _createElementVNode("th", { scope: "col" }, "자녀 1인"),
                  _createElementVNode("th", { scope: "col" }, "자녀 2인"),
                  _createElementVNode("th", { scope: "col" }, "자녀 3인"),
                  _createElementVNode("th", { scope: "col" }, "자녀 4인 이상"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_109, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(100, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_110, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(101, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_111, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(102, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_112, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(103, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_113, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(104, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_114, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(105, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_115, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(100, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(101, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(102, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(103, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(104, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(105, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_116, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성매매유형")
          ], -1)),
          _createElementVNode("div", _hoisted_117, [
            ($setup.state.sYear >= 2019)
              ? (_openBlock(), _createElementBlock("table", _hoisted_118, [
                  _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" (전업형) "),
                        _createElementVNode("br"),
                        _createTextVNode(" 집결지 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" (전업형) "),
                        _createElementVNode("br"),
                        _createTextVNode(" 오피스텔 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 겸업형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (기존산업형) ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 위장형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (기존산업형) ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "출장형"),
                      _createElementVNode("th", { scope: "col" }, "온라인"),
                      _createElementVNode("th", { scope: "col" }, "해외성매매"),
                      _createElementVNode("th", { scope: "col" }, "기타"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 기록 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 없음 ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        id: "last_th"
                      }, "총합")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_119, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(106, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_120, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(251, $setup.state.data) + $setup.CommonUtils.getCntByCn(230, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_121, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(252, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_122, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(253, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_123, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(254, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_124, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(255, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_125, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(234, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_126, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(195, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_127, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(113, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_128, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(106, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(251, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(230, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(252, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(253, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(254, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(255, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(234, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(195, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(113, $setup.state.data),
                                        )), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_129, [
                  _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "집결지"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 오피스텔 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "식품접객업소"),
                      _createElementVNode("th", { scope: "col" }, "위생접객업소"),
                      _createElementVNode("th", { scope: "col" }, "마사지업소"),
                      _createElementVNode("th", { scope: "col" }, "풍속영업업소"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 변종 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 전자형성매매 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (조건만남)-개인 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 전자형성매매 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (조건만남)-알선 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 길거리 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 출장형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "외국인전용클럽"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 해외 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "기타"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 기록 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 없음 ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        id: "last_th"
                      }, "총합")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_130, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(106, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_131, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(230, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_132, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(107, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_133, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(108, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_134, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(109, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_135, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(192, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_136, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(193, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_137, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(231, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_138, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(232, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_139, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(233, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_140, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(111, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_141, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(110, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_142, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(234, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_143, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(195, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_144, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(113, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_145, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(106, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(230, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(107, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(108, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(109, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(192, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(193, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(231, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(232, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(233, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(111, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(110, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(234, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(195, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(113, $setup.state.data),
                                        )), 1)
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_146, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성매매지역")
          ], -1)),
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("table", _hoisted_148, [
              _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "강남"),
                  _createElementVNode("th", { scope: "col" }, "강동"),
                  _createElementVNode("th", { scope: "col" }, "강북"),
                  _createElementVNode("th", { scope: "col" }, "강서"),
                  _createElementVNode("th", { scope: "col" }, "관악"),
                  _createElementVNode("th", { scope: "col" }, "광진"),
                  _createElementVNode("th", { scope: "col" }, "구로"),
                  _createElementVNode("th", { scope: "col" }, "금천"),
                  _createElementVNode("th", { scope: "col" }, "노원"),
                  _createElementVNode("th", { scope: "col" }, "도봉"),
                  _createElementVNode("th", { scope: "col" }, "동대문"),
                  _createElementVNode("th", { scope: "col" }, "동작"),
                  _createElementVNode("th", { scope: "col" }, "마포"),
                  _createElementVNode("th", { scope: "col" }, "서대문"),
                  _createElementVNode("th", { scope: "col" }, "서초"),
                  _createElementVNode("th", { scope: "col" }, "성동"),
                  _createElementVNode("th", { scope: "col" }, "성북"),
                  _createElementVNode("th", { scope: "col" }, "송파"),
                  _createElementVNode("th", { scope: "col" }, "양천"),
                  _createElementVNode("th", { scope: "col" }, "영등포"),
                  _createElementVNode("th", { scope: "col" }, "용산"),
                  _createElementVNode("th", { scope: "col" }, "은평"),
                  _createElementVNode("th", { scope: "col" }, "종로"),
                  _createElementVNode("th", { scope: "col" }, "중구"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "중랑")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_149, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(116, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_150, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(117, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_151, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(118, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_152, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(119, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_153, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(120, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_154, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(121, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_155, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(122, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_156, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(123, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_157, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(124, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_158, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(125, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_159, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(126, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_160, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(127, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_161, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(128, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_162, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(129, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_163, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(130, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_164, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(131, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_165, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(132, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_166, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(133, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_167, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(134, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_168, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(135, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_169, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(136, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_170, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(137, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_171, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(138, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_172, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(168, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_173, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(169, $setup.state.data))), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_174, [
            _createElementVNode("table", _hoisted_175, [
              _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "광주광역시"),
                  _createElementVNode("th", { scope: "col" }, "대구광역시"),
                  _createElementVNode("th", { scope: "col" }, "대전광역시"),
                  _createElementVNode("th", { scope: "col" }, "부산광역시"),
                  _createElementVNode("th", { scope: "col" }, "울산광역시"),
                  _createElementVNode("th", { scope: "col" }, "인천광역시"),
                  _createElementVNode("th", { scope: "col" }, "강원도"),
                  _createElementVNode("th", { scope: "col" }, "경기도"),
                  _createElementVNode("th", { scope: "col" }, "경상남도"),
                  _createElementVNode("th", { scope: "col" }, "경상북도"),
                  _createElementVNode("th", { scope: "col" }, "전라남도"),
                  _createElementVNode("th", { scope: "col" }, "전라북도"),
                  _createElementVNode("th", { scope: "col" }, "제주도"),
                  _createElementVNode("th", { scope: "col" }, "충청남도"),
                  _createElementVNode("th", { scope: "col" }, "충청북도"),
                  _createElementVNode("th", { scope: "col" }, "외국"),
                  _createElementVNode("th", { scope: "col" }, "인터넷"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_176, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(170, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_177, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(171, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_178, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(172, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_179, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(173, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_180, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(174, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_181, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(175, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_182, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(176, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_183, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(177, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_184, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(178, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_185, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(179, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_186, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(180, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_187, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(181, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_188, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(182, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_189, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(183, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_190, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(184, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_191, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(115, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_192, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(190, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_193, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(185, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_194, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(115, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(116, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(117, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(118, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(119, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(120, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(121, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(122, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(123, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(124, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(125, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(126, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(127, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(128, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(129, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(130, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(131, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(132, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(133, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(134, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(135, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(136, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(137, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(138, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(168, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(169, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(170, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(171, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(172, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(173, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(174, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(175, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(176, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(177, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(178, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(179, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(180, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(181, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(182, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(183, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(184, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(185, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(190, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        ($setup.state.sYear < 2019)
          ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "area_contents_title" }, [
                _createElementVNode("p", null, "종사시간")
              ], -1)),
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("table", _hoisted_197, [
                  _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "1개월미만"),
                      _createElementVNode("th", { scope: "col" }, "1개월이상~6개월미만"),
                      _createElementVNode("th", { scope: "col" }, "6개월이상~1년미만"),
                      _createElementVNode("th", { scope: "col" }, "1년"),
                      _createElementVNode("th", { scope: "col" }, "2년"),
                      _createElementVNode("th", { scope: "col" }, "3년"),
                      _createElementVNode("th", { scope: "col" }, "4년"),
                      _createElementVNode("th", { scope: "col" }, "5년"),
                      _createElementVNode("th", { scope: "col" }, "6년"),
                      _createElementVNode("th", { scope: "col" }, "7년"),
                      _createElementVNode("th", { scope: "col" }, "8년"),
                      _createElementVNode("th", { scope: "col" }, "9년"),
                      _createElementVNode("th", { scope: "col" }, "10년"),
                      _createElementVNode("th", { scope: "col" }, "10년이상"),
                      _createElementVNode("th", { scope: "col" }, "기록없음"),
                      _createElementVNode("th", {
                        scope: "col",
                        id: "last_th"
                      }, "총합")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_198, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(196, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_199, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(197, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_200, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(198, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_201, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(199, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_202, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(200, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_203, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(201, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_204, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(202, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_205, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(203, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_206, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(204, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_207, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(205, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_208, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(206, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_209, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(207, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_210, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(208, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_211, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(209, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_212, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(236, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_213, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(196, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(197, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(198, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(199, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(200, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(201, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(202, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(203, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(204, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(205, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(206, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(207, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(208, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(209, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(236, $setup.state.data),
                                    )), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_214, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "선불액수")
          ], -1)),
          _createElementVNode("div", _hoisted_215, [
            _createElementVNode("table", _hoisted_216, [
              _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "300만원미만"),
                  _createElementVNode("th", { scope: "col" }, "300~700만원미만"),
                  _createElementVNode("th", { scope: "col" }, "700~1,000만원미만"),
                  _createElementVNode("th", { scope: "col" }, "1,000~2,000만원미만"),
                  _createElementVNode("th", { scope: "col" }, "2,000~5,000만원미만"),
                  _createElementVNode("th", { scope: "col" }, "5,000~1억원미만"),
                  _createElementVNode("th", { scope: "col" }, "1억원 미만"),
                  _createElementVNode("th", { scope: "col" }, "그외 채무"),
                  _createElementVNode("th", { scope: "col" }, "없음"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_217, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(187, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_218, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(150, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_219, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(151, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_220, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(152, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_221, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(153, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_222, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(154, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_223, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(155, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_224, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(189, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_225, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(188, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_226, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(156, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_227, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(187, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(150, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(151, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(152, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(153, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(154, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(155, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(156, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(188, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(189, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_228, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "가출경험유무")
          ], -1)),
          _createElementVNode("div", _hoisted_229, [
            _createElementVNode("table", _hoisted_230, [
              _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "있음"),
                  _createElementVNode("th", { scope: "col" }, "없음"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_231, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(215, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_232, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(216, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_233, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(217, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_234, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(215, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(216, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(217, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_235, [
          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성폭력유무")
          ], -1)),
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("table", _hoisted_237, [
              _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "있음"),
                  _createElementVNode("th", { scope: "col" }, "없음"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_238, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(218, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_239, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(219, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_240, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(220, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_241, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(218, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(219, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(220, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_242, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "가정폭력유무")
          ], -1)),
          _createElementVNode("div", _hoisted_243, [
            _createElementVNode("table", _hoisted_244, [
              _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "있음"),
                  _createElementVNode("th", { scope: "col" }, "없음"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_245, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(212, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_246, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(213, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_247, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(214, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_248, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(212, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(213, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(214, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_249, [
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "알선고리")
          ], -1)),
          _createElementVNode("div", _hoisted_250, [
            _createElementVNode("table", _hoisted_251, [
              _cache[40] || (_cache[40] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "보도방"),
                  _createElementVNode("th", { scope: "col" }, "소개업자"),
                  _createElementVNode("th", { scope: "col" }, "사채업자"),
                  _createElementVNode("th", { scope: "col" }, "업주"),
                  _createElementVNode("th", { scope: "col" }, "업소관계자"),
                  _createElementVNode("th", { scope: "col" }, "친구,지인"),
                  _createElementVNode("th", { scope: "col" }, "보호자,가족"),
                  _createElementVNode("th", { scope: "col" }, "홍보물"),
                  _createElementVNode("th", { scope: "col" }, "구인구직사이트"),
                  _createElementVNode("th", { scope: "col" }, "채팅앱"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_252, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(260, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_253, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(261, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_254, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(262, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_255, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(263, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_256, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(264, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_257, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(265, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_258, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(266, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_259, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(267, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_260, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(268, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_261, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(269, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_262, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(270, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_263, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(271, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_264, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(260, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(261, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(262, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(263, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(264, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(265, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(266, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(267, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(268, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(269, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(270, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(271, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_265, [
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담유형")
          ], -1)),
          _createElementVNode("div", _hoisted_266, [
            _createElementVNode("table", _hoisted_267, [
              _cache[42] || (_cache[42] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "전화상담"),
                  _createElementVNode("th", null, "내방상담"),
                  _createElementVNode("th", null, "방문상담"),
                  _createElementVNode("th", null, "사이버"),
                  _createElementVNode("th", null, "서신"),
                  _createElementVNode("th", null, "아웃리치"),
                  _createElementVNode("th", null, "온라인 상담"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1, $setup.state.data) - $setup.CommonUtils.getCntByCn(56, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(2, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(3, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(5, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(95, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(6, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(620, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(1, $setup.state.data) -
                                            $setup.CommonUtils.getCntByCn(56, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(2, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(3, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(5, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(95, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(6, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(620, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_268))
}